import { render, staticRenderFns } from "./mapaAvalicaoTurma.vue?vue&type=template&id=28ecdfb5&"
import script from "./mapaAvalicaoTurma.vue?vue&type=script&lang=js&"
export * from "./mapaAvalicaoTurma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports